import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

// Service
import { UiService } from 'src/app/platform/services/ui.service';
import { UserService } from 'src/app/modules/account/user.service';
import { DeviceService } from 'src/app/platform/services/device.service';
import { Credentials } from 'capacitor-native-biometric';

@Component({
  selector: 'app-accounts-biometric-add',
  templateUrl: './accounts-biometric-add.component.html',
  styleUrls: ['./accounts-biometric-add.component.scss']
})
export class AccountsBiometricAddComponent implements OnInit {
  @Input() public username = '';
  @Input() public password = '';

  public dontAsk = false;

  constructor(
    private dialog: MatDialogRef<AccountsBiometricAddComponent>,
    private deviceService: DeviceService,
  ) {}

  ngOnInit(): void {
    const biometricAsk = localStorage.getItem('loginBiometricAsk');
    const biometricLogin = localStorage.getItem('loginBiometric');

    console.log('biometric states', { biometricAsk, biometricLogin });

    if(biometricLogin !== 'false'){
      this.deviceService.biometricVerification().then((valid: boolean | undefined) => {
        if(valid === true){

        } else {
          this.dialog.close({ username: '', password: '' });
        }
      });
    } else {
      if(biometricAsk === 'false'){
        this.dialog.close({ username: '', password: '' });
      }
    }
  }

  onCancel(){
    this.ask();
    this.dialog.close({ username: '', password: '' });
  }

  onAdd(): void{
    this.ask();
    this.deviceService.biometricVerification().then((valid: boolean | undefined) => {
      if(valid === true){
        this.deviceService.biometricSetCredentials(this.username, this.password).then(() => {
          localStorage.setItem('loginBiometric', 'true');

          this.dialog.close();
        });
      }
    });
  }

  ask(){
    console.log('ask', this.dontAsk);
    if(this.dontAsk){
      localStorage.setItem('loginBiometricAsk', 'false');
    }
  }
}
